import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer
      className="text-white py-16 px-6 relative overflow-hidden"
      style={{ background: 'linear-gradient(160deg, #1a0000 0%, #2d0000 40%, #1a0000 100%)' }}
    >
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <img
          src="https://public.readdy.ai/ai/img_res/adaf8a1c49194bad4c4739843ea15c88.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative max-w-7xl mx-auto">
        {/* Logo + tagline banner */}
        <div className="flex flex-col items-center mb-14 pb-10 border-b border-white/10">
          <img
            src="https://public.readdy.ai/ai/img_res/a4aeee0d-6a26-4433-b892-d38374e82571.png"
            alt="Starkvegas Threads by On Target Print Solutions"
            style={{
              height: '110px',
              width: 'auto',
              display: 'block',
              filter: 'drop-shadow(0 0 0.5px white) drop-shadow(0 0 0.5px white)',
            }}
          />
          <p className="text-white/50 text-sm mt-4 tracking-widest uppercase font-semibold">
            Custom Bulldogs Apparel · Printed Locally in Starkville, MS
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <p className="text-white/60 text-sm leading-relaxed mb-5">
              Custom Bulldogs apparel printed locally in Starkville. Hail State gear made with pride, every single order.
            </p>
            <div className="flex gap-3">
              {['ri-facebook-fill', 'ri-instagram-line', 'ri-twitter-x-line', 'ri-tiktok-line'].map((icon, i) => (
                <a
                  key={i}
                  href="#"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-lg hover:bg-[#6B0000] transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Shop */}
          <div>
            <h4 className="font-bold text-xs uppercase tracking-widest text-[#ff9999] mb-5">Shop</h4>
            <ul className="space-y-3">
              {[
                { label: 'All Bulldogs Tees', to: '/shop' },
                { label: 'Best Sellers', to: '/best-sellers' },
                { label: 'Game Day Tees', to: '/shop' },
                { label: 'Custom Name Shirts', to: '/customize' },
                { label: 'Design Your Shirt', to: '/customize' },
              ].map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-white/50 hover:text-white transition-colors text-sm cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-bold text-xs uppercase tracking-widest text-[#ff9999] mb-5">Support</h4>
            <ul className="space-y-3">
              {[
                { label: 'About Us', to: '/about' },
                { label: 'Contact', to: '/contact' },
                { label: 'Shipping Info', to: '/shipping' },
                { label: 'Returns & Exchanges', to: '/returns' },
                { label: 'FAQ', to: '/faq' },
              ].map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-white/50 hover:text-white transition-colors text-sm cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-xs uppercase tracking-widest text-[#ff9999] mb-5">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-2-line text-[#ff9999] text-base"></i>
                </div>
                <span className="text-white/50 text-sm">1085 Stark Road Suite 106,<br />Starkville, MS 39759</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-[#ff9999] text-base"></i>
                </div>
                <a href="tel:6622424286" rel="nofollow" className="text-white/50 hover:text-white transition-colors text-sm cursor-pointer">
                  (662) 242-4286
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-mail-line text-[#ff9999] text-base"></i>
                </div>
                <a href="mailto:info@ontargetprintsolutions.com" rel="nofollow" className="text-white/50 hover:text-white transition-colors text-sm cursor-pointer">
                  info@ontargetprintsolutions.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-[#ff9999] text-base"></i>
                </div>
                <span className="text-white/50 text-sm">Mon–Fri: 9am–6pm CST</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/30 text-sm">
            © 2025 On Target Prints · Starkvegas Threads. All rights reserved. Starkville, MS.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-white/30 hover:text-white transition-colors text-sm whitespace-nowrap cursor-pointer">Privacy Policy</Link>
            <Link to="/terms" className="text-white/30 hover:text-white transition-colors text-sm whitespace-nowrap cursor-pointer">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
